import React from 'react';
import classes from './style.module.scss';
import classNames from 'classnames';

export default ({
    children,
    gridTemplate = "none",
    lastRow = false,
    style,
    compact = false,
    className
}) => (
    <div
        className={classNames(classes.inputRow, {
            [classes.compact]: compact,
            [className]: className
        })}
        style={{
            gridTemplateColumns: gridTemplate,
            marginBottom: lastRow ? 0 : "1.25rem",
            ...style
        }}
    >
        {children}
    </div>
);